import {
	Card,
	Divider,
	Group,
	Skeleton,
	Stack,
	createStyles,
} from '@mantine/core';
import {
	PageLayoutContent,
	PageLayoutContentWrapper,
	PageLayoutOuterWrapper,
	PageLayoutWrapper,
} from '../../../components/PageLayout';
import {
	NavBarSidesheetControlsWrapper,
	NavBarWrapper,
} from '../../../components/SecodaAppShell/SecodaNavBar';

const useStyles = createStyles((theme) => ({
	card: {
		backgroundColor: theme.other.getColor('surface/primary/default'),
		border: `1px solid ${theme.other.getColor('border/secondary/default')}`,
	},
	skeleton: {
		backgroundColor: theme.other.getColor('fill/tertiary/default'),
	},
}));

export function BiDashboardSkeleton() {
	const { classes } = useStyles();

	return (
		<PageLayoutOuterWrapper>
			<PageLayoutWrapper name="bi-dashboard-skeleton">
				<PageLayoutContentWrapper name="bi-dashboard-skeleton">
					<NavBarWrapper>
						<NavBarSidesheetControlsWrapper>
							<Group spacing="xs">
								<Skeleton height={28} width={28} radius="sm" />
								<Skeleton height={28} width={28} radius="sm" />
							</Group>
						</NavBarSidesheetControlsWrapper>
					</NavBarWrapper>
					<PageLayoutContent>
						<Stack spacing="md">
							{/* Header section with logo, title, and navigation */}
							<Stack spacing="sm">
								{/* Logo and title section */}
								<Group spacing="sm" align="center">
									<Skeleton height={28} width={28} radius="sm" />
									<Skeleton height={28} width={120} radius="sm" />
								</Group>

								{/* Primary navigation bar */}
								<Skeleton height={12} width="100%" radius="sm" />

								{/* Secondary navigation tabs */}
								<Group spacing="md" mt="sm">
									<Skeleton height={12} width={80} radius="sm" />
									<Skeleton height={12} width={80} radius="sm" />
									<Skeleton height={12} width={80} radius="sm" />
									<Skeleton height={12} width={80} radius="sm" />
								</Group>
							</Stack>

							<Divider />

							{/* Main content area - 2x3 grid of cards */}
							<Stack spacing="md">
								{[0, 1].map((rowIdx) => (
									<Group spacing="md" grow key={rowIdx}>
										{[0, 1, 2].map((colIdx) => (
											<MetricSkeleton key={`${rowIdx}-${colIdx}`} />
										))}
									</Group>
								))}
							</Stack>
						</Stack>
					</PageLayoutContent>
				</PageLayoutContentWrapper>
			</PageLayoutWrapper>
		</PageLayoutOuterWrapper>
	);
}

export function MetricSkeleton({ key }: { key: string }) {
	const { classes } = useStyles();

	return (
		<Card className={classes.card} p="md" key={key} radius="md" h={364}>
			<Stack spacing="sm" h="100%">
				{/* Card header - two lines */}
				<Stack spacing="xs">
					<Skeleton height={12} width="85%" radius="4px" />
					<Skeleton height={8} width="70%" radius="4px" />
				</Stack>
				{/* Card content - large block */}
				<Skeleton
					height="100%"
					width="100%"
					radius="4px"
					className={classes.skeleton}
				/>
			</Stack>
		</Card>
	);
}
